'use client';

import { useState } from 'react';

interface EmailFormProps {
  ctaText: string;
}

export function EmailForm({ ctaText }: EmailFormProps) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle"|"loading"|"success"|"error">("idle");
  const [error, setError] = useState<string|null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("error");
      setError("Valid email required");
      return;
    }
    
    setStatus("loading");
    try {
      const res = await fetch('/api/waitlist', {
        method: 'POST',
        body: JSON.stringify({ email }),
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!res.ok) throw new Error(await res.text());
      setStatus("success");
    } catch (err) {
      setStatus("error");
      setError(err instanceof Error ? err.message : "Submission failed");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <div className="relative">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          aria-label="Email address"
          required
          className="input w-full"
        />
        {status === 'error' && (
          <p className="absolute -bottom-5 text-sm text-red-500">{error}</p>
        )}
      </div>
      <button 
        type="submit"
        className="btn btn-primary"
        disabled={status === "loading"}
        aria-busy={status === "loading"}
      >
        {status === "loading" ? "Submitting..." : ctaText}
      </button>
      {status === "success" && (
        <p className="text-green-600 text-sm">Thank you! Check your email</p>
      )}
    </form>
  );
} 